import React from 'react';

import { Icon, IconChat } from '@flixbus/honeycomb-icons-react';
import { getVoucherComments } from '../../../apis';
import { useVoucher } from '../../../context/VoucherProdiver';
import InfoDisplay from '../InfoDisplay';
import styles from '../voucher-info.module.scss';
import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';

import { VoucherComment } from '../../../types/Comments';

const VoucherCommentsInfo = () => {
  const { data } = useVoucher();
  const [comments, setComments] = useState<VoucherComment[]>([]);

  useEffect(() => {
    getVoucherComments(data.id).then(res => {
      setComments(res);
    });
  }, [data.id]);

  const mapCommentValue = (comment: VoucherComment) => {
    return <div className={styles.comment}>{comment.content}</div>;
  };

  return (
    <>
      {comments.length > 0 && (
        <div className={styles.container}>
          <InfoDisplay
            title={
              <>
                <Icon appearance={'secondary'} size={4} InlineIcon={IconChat} />
                {' Comments'}
              </>
            }
            fields={comments.map(comment => ({
              label: `${comment.author} | ${
                comment.createdAt
                  ? DateTime.fromISO(comment.createdAt).toFormat('dd.MM.yyyy')
                  : 'unknown date'
              }`,
              value: mapCommentValue(comment),
            }))}
          />
        </div>
      )}
    </>
  );
};

export default VoucherCommentsInfo;
